export default __webpack_public_path__ + "static/media/logo.b40e7e35.png";